import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { showErrorToast, showSuccessToast } from '../../../utils/toastUtils';
import { deLinkTalkingPoint, type TopicDto } from '../../generated/client';
import { queryKeys } from '../../query-keys';

interface IUnlinkTopicParams {
    parentTopicId: number;
    talkingPointId: number;
}

export function useUnlinkTopic(): UseMutationResult<TopicDto, AxiosError, IUnlinkTopicParams> {
    const { t } = useTranslation();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ parentTopicId, talkingPointId }) =>
            deLinkTalkingPoint({ path: { id: parentTopicId, 'talking-point-id': talkingPointId } }).then((result) => result.data!),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.fullTopics() });
            queryClient.invalidateQueries({ queryKey: queryKeys.topics() });
            queryClient.invalidateQueries({ queryKey: queryKeys.topic() });
            showSuccessToast(t('successActionGeneric'));
        },
        onError: (error) => showErrorToast({ error, userMessage: t('failureActionGeneric') }),
    });
}
